// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606050554/js/" + chunkId + "." + {"44":"2bab4000","225":"482e65e0","481":"3a0faeb6","486":"00e9aba5","770":"069c4aa7"}[chunkId] + ".0.5886196905249567.chunk.js";
};